import React, { FC, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { LOGIN } from '../../../constants';

export interface ILogoutProps {
  onLogout: () => Promise<boolean> | void;
}

const Logout: FC<ILogoutProps> = ({ onLogout }) => {
  useEffect(() => {
    onLogout();
  }, [onLogout]);

  return <Redirect to={LOGIN} />;
};

export default Logout;
